module.exports = {
  footerText: '© 2019 Intersistemas, S.A. de C.V. \nEste sitio esta diseñado para el uso de evaluación, los contenidos imágenes y codificaciones son propiedad de Intersistemas, S.A. de C.V.',
};
